import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stocks',
})
export class StocksPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return;
    }
    if (value[0] === '+' || value[1] === '+') {
      value = `<span class="positive">${value}</span>`;
    } else if (value[0] === '-' || value[1] === '-') {
      value = `<span class="negative">${value}</span>`;
    }
    return value;
  }
}
